import { Text } from '@chakra-ui/react';
import { StrategyStat } from 'model/modules/strategies/strategies';
import AppCard from 'presentation/components/shared/card/AppCard';
import CardInfoRow from 'presentation/components/shared/card/CardInfoRow';
import { FC } from 'react';

interface Props {
  statistics: StrategyStat[];
}

const StrategyStatisticCard: FC<Props> = ({ statistics: advantages }) => {
  const infoRowWidth = 'calc(50% - 10px)';

  return (
    <AppCard
      p="20px"
      display="flex"
      flexWrap="wrap"
      justifyContent="space-between"
    >
      {advantages.map((advantage, index) => (
        <CardInfoRow
          key={index}
          width={infoRowWidth}
          label={advantage.label}
          showBorder={index < advantages.length - 2}
          labelProps={{ mr: 0 }}
        >
          <Text minW="50px">{advantage.value}</Text>
        </CardInfoRow>
      ))}
    </AppCard>
  );
};

export default StrategyStatisticCard;
